import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { ITareaDiaria } from "src/app/reusable/app-cronometro/app-cronometro.component";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { Proyectos } from "src/app/shared/model/incidencias/proyectos.model";
import { AutorizacionTiempoExtra } from "src/app/shared/model/tarea/autorizacion-tiempo-extra.model";
import { ResumenJornadaDiaria } from "src/app/shared/model/tarea/resumen-jornada-diaria.model";
import { TareaDiaria } from "src/app/shared/model/tarea/tareaDiaria.model";
import { GenericoService } from "src/app/shared/services/generico.service";
import { SweetAlertComponent } from "src/app/shared/SweetMesssage";
import { Constantes } from "src/app/utilerias/constantes/constantes";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";
import {
  EstatusTarea,
  EstatusTareaEnum,
} from "src/app/utilerias/enums/estatusTareaDiariaEnum";
import { UtileriasService } from "src/app/utilerias/service/utilerias.service";
import { abrirTareaDialogo } from "../tarea-alta/tarea-alta.component";
import { Msg } from "src/app/utilerias/mensajes/Msg";
import swal from "sweetalert2";
import { DatePipe, NgClass, NgIf, NgFor } from "@angular/common";
import { TareaTiempoComponent } from "../tarea-tiempo/tarea-tiempo.component";
import { ProgramacionTarea } from "../../shared/model/tarea/programacionTarea.model";
import { AppCronometroComponent } from "../../reusable/app-cronometro/app-cronometro.component";
import { AppRelojComponent } from "../../reusable/app-reloj/app-reloj.component";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { firstValueFrom } from "rxjs";
import { NgxPaginationModule } from "ngx-pagination";

@Component({
  selector: "app-tarea-consulta",
  standalone: true,
  templateUrl: "./tarea-consulta.component.html",
  styleUrls: ["./tarea-consulta.component.css"],
  imports: [
    NgIf,
    AppCronometroComponent,
    AppRelojComponent,
    MatButtonModule,
    MatTooltip,
    NgClass,
    NgFor,
    DatePipe,
    NgxPaginationModule,
  ],
})
export class TareaConsultaComponent implements OnInit {
  /** Tabla TAREAS */
  consultaTareas = new ConsultaList<TareaDiaria>();
  listaTareas: TareaDiaria[] = [];
  totalRegistrosMisTareas = 0;
  currentPageMisTareas = 1;
  /** Tabla Tareas hoy */
  consultaTareasDiarias = new ConsultaList<TareaDiaria>();
  listaTareasDiarias: TareaDiaria[] = [];
  totalRegistrosTareasHoy = 0;
  currentPageTareasHoy = 1;
  readonly pageSize = 5;
  public labels: { previousLabel: string; nextLabel: string } = {
    previousLabel: "ANTERIOR",
    nextLabel: "SIGUIENTE",
  };
  /** Events */

  @ViewChild("downloadReporteExcell") private downloadReporteExcell: ElementRef;
  /** INSTANCIAS  */
  tareaCronometro: ITareaDiaria;
  usuarioCronometro: ITareaDiaria;
  tareaEntrada: TareaDiaria;
  tareas: TareaDiaria;
  proyectos: Proyectos[];
  /** Variables globales */
  maxDate = new Date();
  misTareasMostrar: boolean;
  activo: boolean;
  valorFec: Boolean;
  nombreTareaActiva: string;
  tiempoTotal: string = "00:00:00";
  resumenJornada: ResumenJornadaDiaria;
  tareaActivaDiaria: TareaDiaria | null = null;

  datePipe = new DatePipe("en-MX");

  constructor(
    private service: GenericoService,
    private utils: UtileriasService,
    private sweetAlert: SweetAlertComponent,
    private dialog: MatDialog,
    private msg: Msg,
    private router: Router
  ) {}

  ngOnInit() {
    this.inicializarValores();
    this.consultaPaginaMisTareas(1);
    this.consultaPaginaTareasHoy(1);
  }

  consultaPaginaMisTareas(page: number): void {
    this.currentPageMisTareas = page;
    this.consultaTareas.bean = this.tareas;
    this.consultaTareas.regInicial = (page - 1) * this.pageSize;
    this.consultaTareas.regXPagina = this.pageSize;
    this.consultaTareas.sort = "id";
    this.consultaTareas.param4 = Constantes.UNO;

    this.service
      .consultarXPaginacion(
        UrlConstantes.CONSULTA_TAREAS_PROYECTO_USUARIO,
        this.consultaTareas
      )
      .subscribe((res) => {
        const tareas = Array.isArray(res?.list) ? res.list : [];
        this.totalRegistrosMisTareas = Number(res?.pTotalItems ?? tareas.length);

        if (tareas.length > Constantes.CERO) {
          this.extraeListaTareas(tareas);
        } else {
          this.listaTareas = [];
        }

        const maxPages = this.totalPagesMisTareas;
        if (maxPages > 0 && this.currentPageMisTareas > maxPages) {
          this.consultaPaginaMisTareas(maxPages);
        }
      });
  }

  consultaPaginaTareasHoy(page: number): void {
    this.currentPageTareasHoy = page;
    this.consultaTareasDiarias.bean = new TareaDiaria();
    this.consultaTareasDiarias.regInicial = (page - 1) * this.pageSize;
    this.consultaTareasDiarias.regXPagina = this.pageSize;
    this.consultaTareasDiarias.sort = "id";
    this.consultaTareasDiarias.param4 = Constantes.UNO;

    this.service
      .consultarXPaginacion(
        UrlConstantes.CONSULTA_TAREA_DIARIA,
        this.consultaTareasDiarias
      )
      .subscribe((res) => {
        const tareasHoy = Array.isArray(res?.list) ? res.list : [];
        this.totalRegistrosTareasHoy = Number(res?.pTotalItems ?? tareasHoy.length);
        this.resumenJornada = res?.beanAlterno as ResumenJornadaDiaria;
        const horasTrabajadas = this.resumenJornada?.horasTrabajadas ?? Constantes.CERO;
        const horasTrabajadasStr =
          this.resumenJornada?.horasTrabajadasStr ?? "00:00:00";

        if (tareasHoy.length > Constantes.CERO) {
          this.extraeListaTareasDiarias(tareasHoy, horasTrabajadas, horasTrabajadasStr);
        } else {
          this.listaTareasDiarias = [];
          this.tareaActivaDiaria = null;
          this.tiempoTotal = horasTrabajadasStr;
        }

        const maxPages = this.totalPagesTareasHoy;
        if (maxPages > 0 && this.currentPageTareasHoy > maxPages) {
          this.consultaPaginaTareasHoy(maxPages);
        }
      });
  }

  extraeListaTareas(listaTareasServ: TareaDiaria[]): void {
    this.listaTareas = listaTareasServ;
    this.listaTareas.forEach((e) => {
      if (e.estatus === EstatusTareaEnum.ACTIVO) {
        e.band = true;
        this.activo = true;
      }
    });
  }

  extraeListaTareasDiarias(
    listaTareasDiariasServ: TareaDiaria[],
    tiempoLaboral: any,
    tiempoLaboralStr: any
  ) {
    this.listaTareasDiarias = listaTareasDiariasServ;
    this.tareaActivaDiaria = null;
    this.activo = false;
    this.nombreTareaActiva = "Sin tarea activa";
    this.usuarioCronometro = new ITareaDiaria(1, "Tiempo total hoy", tiempoLaboral ?? Constantes.CERO);
    this.listaTareasDiarias.forEach((td) => {
      if (td.tiempoTotalInvertidoXDiaStr === null) {
        td.tiempoTotalInvertidoXDiaStr = "00:00:00";
      }
      if (td.estatus === EstatusTareaEnum.ACTIVO) {
        this.nombreTareaActiva = td.nombre;
        this.tareaActivaDiaria = td;
        this.tareaCronometro = new ITareaDiaria(
          td.id,
          td.nombre,
          td.tiempoTotalInvertidoXDia ?? Constantes.CERO
        );
        this.activo = true;
      }
    });
    this.tiempoTotal = tiempoLaboralStr;
  }

  private inicializarValores() {
    this.misTareasMostrar = true;
    this.tareaEntrada = new TareaDiaria();
    this.tareas = new TareaDiaria();
    this.activo = false;
    this.valorFec = false;
    this.tareaCronometro = new ITareaDiaria(2, "Prueba 1", Constantes.CERO);
    this.usuarioCronometro = new ITareaDiaria(2, "Prueba 1", Constantes.CERO);
    this.limpiarFiltros();
  }

  private limpiarFiltros() {
    this.tareas.idProyecto = null;
    this.tareas.nombre = null;
    this.tareas.fecha_inicio = null;
    this.tareas.fecha_fin = null;
  }

  public limpiar() {
    this.tareas.idAreaResolutora = null;
    this.tareas.idAreaSolicitante = null;
    this.tareas.idProyecto = null;
    this.tareas.fecha_inicio = null;
    this.tareas.fecha_fin = null;
    this.refrescarTareas();
  }

  private refrescarTareas() {
    this.consultaPaginaMisTareas(this.currentPageMisTareas);
  }

  private refrescarTareasDiarias() {
    this.consultaPaginaTareasHoy(this.currentPageTareasHoy);
  }

  public registraTarea() {
    firstValueFrom(
      this.service.obtenerElemento(UrlConstantes.RESTRICCION_TAREAS)
    )
      .then((res) => {
        if (res.pCodRetorno === "00001") {
          // ✅ permitido → abre el cuadro de alta
          abrirTareaDialogo(this.dialog, null)
            .afterClosed()
            .subscribe((guardado) => {
              if (guardado) {
                this.refrescarTareas();
                this.refrescarTareasDiarias();
              }
            });
        } else {
          // ❌ no permitido → muestra mensaje
          swal.fire({
            text: res.pMensaje || "No se puede registrar más tareas.",
            icon: "info",
          });
        }
      });
  }

  /** El detalle recibe una copia del renglón (abrirTareaDialogo la hace): no toca la tabla. */
  public verDetalle(row: TareaDiaria) {
    this.tareaEntrada = row;
    abrirTareaDialogo(this.dialog, row)
      .afterClosed()
      .subscribe((guardado) => {
        if (guardado) {
          this.refrescarTareas();
          this.refrescarTareasDiarias();
        }
      });
  }

  public eliminarTarea(row: TareaDiaria) {
    this.tareaEntrada = row;
    firstValueFrom(
      this.service.obtenerElementoPorCampo(UrlConstantes.ELIMINAR_TAREA, row.id)
    )
      .then((res) => {
        if (res.pCodRetorno === "00000") {
          this.sweetAlert.showSwal("error-message", res.pMensaje);
        } else if (res.pCodRetorno === "00001") {
          this.sweetAlert.showSwal("success-message", Constantes.VACIO);
          this.refrescarTareas();
        }
      });
  }

  public establecerTiempoActividad(tarea: TareaDiaria) {
    this.tareaEntrada = tarea;
    this.tareaEntrada.band = true;
    const dialogRef = this.dialog.open(TareaTiempoComponent, {
      height: "auto",
      maxWidth: "850px",
      panelClass: "custom-modalbox",
      disableClose: true,
      data: tarea,
    });
    dialogRef.afterClosed().subscribe((resultado) => {
      this.comprobarRespuestaModal(resultado, tarea);
    });
  }

  private comprobarRespuestaModal(resultado: any, tarea: TareaDiaria) {
    if (resultado == null) {
      const indiceElemento = this.listaTareas.findIndex(
        (item) => tarea.id === item.id
      );
      this.listaTareas[indiceElemento].band = false;
      return;
    }

    if (resultado === Constantes.TAREA_SIN_PROGRAMAR) {
      this.actualizaEstatus(tarea, EstatusTareaEnum.ACTIVO);
      return;
    }

    this.programarTarea(resultado);
  }

  private programarTarea(programacionTarea: ProgramacionTarea) {
    firstValueFrom(
      this.service.agregarElemento(
        UrlConstantes.PROGRAMAR_TAREA,
        programacionTarea
      )
    )
      .then(
        (response) => {
          if (response.pCodRetorno === Constantes.COD_EXITO) {
            this.sweetAlert.showSwal("success-message", null);
          } else {
            this.sweetAlert.showSwal("error-message", null);
          }
          this.refrescarTareas();
          this.refrescarTareasDiarias();
        },
        (error) => {
          this.sweetAlert.showSwal("error-message", error);
        }
      );
  }

  /** 🔹 Cambiado: ahora solo se permite una tarea activa */
  public actualizaEstatus(tarea: TareaDiaria, estatus: any) {
    // Si quiero activar una tarea, pauso todas las demás activas
    if (estatus === EstatusTareaEnum.ACTIVO) {
      this.listaTareasDiarias
        .filter(
          (t) => t.estatus === EstatusTareaEnum.ACTIVO && t.id !== tarea.id
        )
        .forEach((t) => {
          t.estatus = EstatusTareaEnum.PAUSADO;
          this.service
            .obtenerElementoPorCampoPost(
              UrlConstantes.CAMBIO_ESTATUS_TAREA_DIARIA,
              t
            )
            .subscribe();
        });
    }

    tarea.estatus = EstatusTarea.obtenerEnum(estatus);

    this.service
      .obtenerElementoPorCampoPost(
        UrlConstantes.CAMBIO_ESTATUS_TAREA_DIARIA,
        tarea
      )
      .subscribe((res) => {
        if (res != null) {
          if (res.pCodRetorno === "00002") {
            this.sweetAlert.showSwal("error-message-msg", res.pMensaje);
          } else if (res.pCodRetorno !== "00000") {
            this.sweetAlert.showSwal(
              "error-message-msg",
              res.pMensaje || "No fue posible actualizar la tarea."
            );
          } else {
            this.sweetAlert.showSwal("success-message", Constantes.VACIO);
          }

          if (
            EstatusTareaEnum.PAUSADO === res.estatus ||
            EstatusTareaEnum.TERMINADO === res.estatus
          ) {
            this.activo = false;
          } else if (EstatusTareaEnum.ACTIVO === res.estatus) {
            this.activo = true;
          }

          this.tareaCronometro = new ITareaDiaria(
            res.id,
            res.nombre,
            res.tiempoTotalInvertidoXDia
          );
          this.refrescarTareasDiarias();
        } else {
          this.sweetAlert.showSwal("error-message", Constantes.VACIO);
        }
      });
  }

  descargarBitacora() {
    firstValueFrom(this.service.descargarBitacora("bitacoraUsuario.do", "0"))
      .then((resp) => {
        const blob = new Blob([resp], {
          type: "application/x-download",
        });
        const fileUrl = window.URL.createObjectURL(blob);
        const link = this.downloadReporteExcell.nativeElement;
        link.href = fileUrl;
        link.download = "Bitacora.xlsx";
        link.click();
        window.URL.revokeObjectURL(fileUrl);
      })
      .catch(() => {
        this.msg.errorCall(
          "No se pudo descargar la bítacora, intente más tarde",
          null,
          null
        );
      });
  }

  abrirCapturaManual(): void {
    this.router.navigate(["/TAREA/captura-manual-semanal"]);
  }

  get totalPagesMisTareas(): number {
    return this.totalRegistrosMisTareas > 0
      ? Math.ceil(this.totalRegistrosMisTareas / this.pageSize)
      : 0;
  }

  get showPaginationMisTareas(): boolean {
    return this.totalRegistrosMisTareas > 0 || this.listaTareas.length > 0;
  }

  get totalPagesTareasHoy(): number {
    return this.totalRegistrosTareasHoy > 0
      ? Math.ceil(this.totalRegistrosTareasHoy / this.pageSize)
      : 0;
  }

  get showPaginationTareasHoy(): boolean {
    return this.totalRegistrosTareasHoy > 0 || this.listaTareasDiarias.length > 0;
  }

  get horaEntradaTexto(): string {
    return this.formateaHora(this.resumenJornada?.jornada?.horaEntrada);
  }

  get horaSalidaTexto(): string {
    return this.formateaHora(this.resumenJornada?.jornada?.horaSalida);
  }

  get bloquesComidaTexto(): string {
    const bloques = this.resumenJornada?.jornada?.bloquesComida ?? [];
    if (!bloques.length) {
      return "Sin bloque de comida configurado";
    }
    return bloques
      .map(
        (bloque) =>
          `${this.formateaHora(bloque.horaInicio)} - ${this.formateaHora(
            bloque.horaFin
          )}`
      )
      .join(" | ");
  }

  get minutosObjetivoTexto(): string {
    return this.formateaMinutos(this.resumenJornada?.minutosObjetivo ?? 0);
  }

  get minutosRestantesTexto(): string {
    return this.formateaMinutos(this.resumenJornada?.minutosRestantes ?? 0);
  }

  get minutosExcedentesTexto(): string {
    return this.formateaMinutos(this.resumenJornada?.minutosExcedentes ?? 0);
  }

  get estadoTiempoExtraClase(): string {
    switch (this.resumenJornada?.estadoTiempoExtra) {
      case "APROBADO":
      case "NORMAL":
        return "is-active";
      case "PENDIENTE":
        return "is-pending";
      case "RECHAZADO":
        return "is-danger";
      default:
        return "is-inactive";
    }
  }

  get estadoTiempoExtraTexto(): string {
    switch (this.resumenJornada?.estadoTiempoExtra) {
      case "NORMAL":
        return "Dentro de jornada";
      case "POR_SOLICITAR":
        return "Requiere solicitud";
      case "PENDIENTE":
        return "Pendiente de autorización";
      case "APROBADO":
        return "Exceso aprobado";
      case "RECHAZADO":
        return "Exceso rechazado";
      default:
        return "Sin jornada configurada";
    }
  }

  solicitarAutorizacionTiempoExtra(): void {
    if (!this.resumenJornada?.permiteSolicitud) {
      return;
    }

    swal
      .fire({
        title: "Solicitar autorización",
        input: "textarea",
        inputLabel: "Motivo del exceso",
        inputPlaceholder:
          "Explica por qué fue necesario exceder tu jornada de hoy.",
        showCancelButton: true,
        confirmButtonText: "Enviar solicitud",
        cancelButtonText: "Cancelar",
        inputValidator: (value) => {
          if (!value?.trim()) {
            return "Captura el motivo para enviar la solicitud.";
          }
          return null;
        },
      })
      .then((result) => {
        if (!result.isConfirmed || !result.value?.trim()) {
          return;
        }

        const payload = new AutorizacionTiempoExtra();
        const idProyecto =
          this.tareaActivaDiaria?.idProyecto ??
          this.listaTareasDiarias.find((item) => !!item.idProyecto)?.idProyecto;
        payload.fechaTrabajo = this.consultaTareasDiarias?.bean?.fecha_inicio ?? new Date();
        payload.idProyecto = idProyecto ? String(idProyecto) : null;
        payload.idTarea = this.tareaActivaDiaria?.id ?? null;
        payload.minutosSolicitados = this.resumenJornada.minutosExcedentes;
        payload.motivoEmpleado = result.value.trim();
        payload.origenRegistro = "TIMER";

        this.service
          .agregarElemento(UrlConstantes.SOLICITAR_TIEMPO_EXTRA, payload)
          .subscribe((response) => {
            if (response?.pCodRetorno === "00000") {
              this.sweetAlert.showSwal("success-message-msg", response.pMensaje);
              this.refrescarTareasDiarias();
            } else {
              this.sweetAlert.showSwal(
                "error-message-msg",
                response?.pMensaje || "No fue posible registrar la solicitud."
              );
            }
          });
      });
  }

  irAAutorizaciones(): void {
    this.router.navigate(["/TAREA/autorizaciones"]);
  }

  irABitacoras(): void {
    this.router.navigate(["/TAREA/bitacoras"]);
  }

  private formateaHora(valor: string | Date | undefined | null): string {
    if (!valor) {
      return "--:--";
    }
    if (valor instanceof Date) {
      return this.datePipe.transform(valor, "HH:mm") ?? "--:--";
    }
    return String(valor).slice(0, 5);
  }

  private formateaMinutos(minutos: number): string {
    const total = Number(minutos ?? 0);
    const horas = Math.floor(total / 60);
    const minutosRestantes = total % 60;
    return `${horas}h ${String(minutosRestantes).padStart(2, "0")}m`;
  }
}
